import Link from 'next/link';

export default function HeroSection() {
  return (
    <section
      className="relative overflow-hidden"
      style={{
        background: 'linear-gradient(135deg, #1e1e1e 0%, #272727 50%, #222222 100%)',
        minHeight: '580px',
      }}
    >
      <div
        className="absolute inset-0 pointer-events-none"
        style={{ background: 'radial-gradient(ellipse at 75% 50%, rgba(0,150,136,0.08) 0%, transparent 60%)' }}
      />
      <div
        className="absolute top-0 left-0 right-0 h-px"
        style={{ background: 'linear-gradient(90deg, transparent 0%, rgba(0,150,136,0.6) 40%, rgba(0,150,136,0.6) 60%, transparent 100%)' }}
      />
      <div className="relative max-w-6xl mx-auto px-6 py-24 lg:py-32">
        <div className="max-w-3xl">
          {/* Section label */}
          <div className="flex items-center gap-3 mb-6">
            <div className="h-px w-8" style={{ backgroundColor: 'rgba(0,150,136,0.4)' }} />
            <span style={{ fontFamily: 'DM Sans, sans-serif', fontSize: '0.72rem', fontWeight: 600, letterSpacing: '0.12em', textTransform: 'uppercase', color: 'rgba(0,150,136,0.75)' }}>
              Serviço GP Otimiza da GestPub
            </span>
          </div>

          <h1
            className="text-white mb-5"
            style={{ fontFamily: 'DM Sans, sans-serif', fontSize: 'clamp(2rem, 4vw, 2.75rem)', lineHeight: 1.2, fontWeight: 700, letterSpacing: '-0.02em' }}
          >
            Governar melhor começa por dentro.
          </h1>

          <p
            className="mb-4"
            style={{ fontFamily: 'DM Sans, sans-serif', fontSize: '1.05rem', lineHeight: 1.7, color: 'rgba(255,255,255,0.72)', maxWidth: '58ch', fontWeight: 400 }}
          >
            O GP Otimiza ajuda Municípios a reorganizar estruturas, clarificar funções, simplificar processos e melhorar a capacidade de execução das prioridades do executivo municipal.
          </p>

          <p
            className="mb-10"
            style={{ fontFamily: 'DM Sans, sans-serif', fontSize: '0.9rem', fontWeight: 600, letterSpacing: '0.08em', color: 'rgba(0,150,136,0.85)' }}
          >
            Pessoas. Processos. Desempenho.
          </p>

          {/* CTA buttons */}
          <div className="flex flex-col sm:flex-row gap-3">
            <Link
              href="/multi-step-questionnaire"
              className="inline-flex items-center justify-center gap-2.5 px-8 py-3.5 bg-white text-gray-900 font-semibold text-sm transition-all duration-200 hover:bg-gray-100"
              style={{ fontFamily: 'DM Sans, sans-serif', borderRadius: '4px', letterSpacing: '0.01em' }}
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                <path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2" />
                <rect x="9" y="3" width="6" height="4" rx="1" />
                <line x1="9" y1="12" x2="15" y2="12" />
                <line x1="9" y1="16" x2="12" y2="16" />
              </svg>
              Iniciar diagnóstico gratuito
            </Link>
            <a
              href="#o-que-e"
              className="inline-flex items-center justify-center gap-2.5 px-8 py-3.5 bg-transparent text-white font-medium text-sm transition-all duration-200"
              style={{ fontFamily: 'DM Sans, sans-serif', borderRadius: '4px', border: '1px solid rgba(255,255,255,0.22)', letterSpacing: '0.01em' }}
              onMouseEnter={(e) => { (e.currentTarget as HTMLAnchorElement).style.borderColor = 'rgba(255,255,255,0.45)'; }}
              onMouseLeave={(e) => { (e.currentTarget as HTMLAnchorElement).style.borderColor = 'rgba(255,255,255,0.22)'; }}
            >
              Conhecer o serviço
            </a>
          </div>

          {/* Trust indicators */}
          <div
            className="flex flex-wrap items-center gap-x-7 gap-y-3 mt-10 pt-8"
            style={{ borderTop: '1px solid rgba(255,255,255,0.07)' }}
          >
            {[
              'Diagnóstico gratuito',
              'Confidencialidade garantida',
              'Resultado imediato',
              'Serviço especializado da GestPub',
            ].map((text) => (
              <div key={text} className="flex items-center gap-2" style={{ color: 'rgba(255,255,255,0.48)' }}>
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="rgba(0,150,136,0.6)" strokeWidth="2.5" aria-hidden="true">
                  <polyline points="20 6 9 17 4 12" />
                </svg>
                <span style={{ fontFamily: 'DM Sans, sans-serif', fontSize: '0.78rem' }}>{text}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}